module.exports = __webpack_public_path__ + "img/1-1.2钱文忠（学者）.0faad75e.jpg";